export default function DataList({children}){
    return(
        <div className="data-list">
            {children}
        </div>
    )
}